import axios from 'axios';

export const createS3Path = ({ email, category, type, season, color, brand }) => {
  const path = `${email}/${type}/${category}`;
  // TODO: These parameters are currently unused but may be needed in the future
  // if (brand) {
  //   path += `/${brand}`;
  // }
  // if (season) {
  //   path += `/${season}`;
  // }
  // if (color) {
  //   path += `/${color}`;
  // }

  // Mark unused parameters to avoid ESLint warnings
  void season;
  void color;
  void brand;

  return path;
};

export const checkUploadFileSize = (files, size) => {
  files = Array.from(files);
  return files.reduce((ac, file) => {
    if (file.size <= size) {
      ac.push(file);
    }
    return ac;
  }, []);
};

export const getClosets = (userId, a) => {
  let params = '';
  Object.entries(a).forEach(([key, value]) => {
    if (key === 'category') {
      value.forEach(element => {
        params += `${params ? '&' : '/?'}${key}[]=${element}`;
      });
    } else if (value) {
      params += `${params ? '&' : '/?'}${key}[]=${value}`;
    }
  });
  return axios.get(`${process.env.REACT_APP_BASE_URL}/closet/${userId}${params}`);
};

// Function to format date to "July 1, 2025, 8:20 am" format
export const formatDate = dateString => {
  try {
    const date = new Date(dateString);

    // Check if date is valid
    if (isNaN(date.getTime())) {
      return dateString;
    }

    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    };

    return date.toLocaleDateString('en-US', options).replace(' at ', ', ');
  } catch {
    return dateString;
  }
};

/**
 * Parses URL query parameters into an object
 * @param {string} search - The URL search string (e.g., "?param1=value1&param2=value2")
 * @returns {Object} Parsed parameters object
 */
export const parseUrlParameters = search => {
  const parameters = {};
  const queryString = search.split('?')[1];

  if (queryString) {
    const params = queryString.split('&');
    params.forEach(param => {
      const [key, value] = param.split('=');
      if (key && value) {
        parameters[decodeURIComponent(key)] = decodeURIComponent(value);
      }
    });
  }

  return parameters;
};

/**
 * Creates initial customer data object from URL parameters
 * @param {Object} parameters - Parsed URL parameters
 * @returns {Object} Customer data object with default values
 */
export const createCustomerDataFromParams = parameters => {
  return {
    id: parameters.id || '',
    email: parameters.email || '',
    phone: parameters.phone || '',
    first_name: parameters.first_name || '',
    last_name: parameters.last_name || '',
    height: '',
    weight: '',
    preferred_style: '',
    body_shape: '',
    chat_sessions_available: 0,
    video_sessions_available: 0,
    total_chat_sessions: 0,
    total_video_sessions: 0,
  };
};
